export default __webpack_public_path__ + "static/media/Add_Classification_Category.1857d1f5.png";